<div class="pgc-filter-container">

  <!-- Botão para abrir o modal de filtros -->
  <div class="pgc-filter-toggle">
    <po-button
      p-icon="an an-funnel"
      p-label="{{ literals?.str0879 }}"
      p-kind="tertiary"
      (p-click)="openModal()">
    </po-button>

    @if (hasActiveFilter) {
      <po-tag
        class="po-ml-1"
        p-color="color-08"
        p-icon="an an-funnel"
        [p-value]="activeFilterLabel"
        p-tooltip="{{ literals?.str0880 }}"
        (p-click)="openModal()">
      </po-tag>
    }
  </div>

  <!-- Modal de filtros -->
  <po-modal
    #filterModal
    p-title="{{ literals?.str0879 }}"
    p-size="lg"
    p-click-out="true"
    [p-primary-action]="primaryAction"
    [p-secondary-action]="secondaryAction">

    <!-- Seleção de filtro salvo -->
    <div class="po-row po-mb-2">
      <div class="po-md-6">
        <po-combo
          p-label="{{ literals?.str0881 }}"
          p-placeholder="{{ literals?.str0882 }}"
          [p-options]="filterNameOptions"
          [(ngModel)]="selectedFilterName"
          (p-change)="loadFilter($event)"
          p-clean>
        </po-combo>
      </div>
      <div class="po-md-3 po-mt-1 filter-actions">
        <po-button
          p-icon="an an-pencil-simple"
          p-label="{{ literals?.str0213 }}"
          p-kind="tertiary"
          [p-disabled]="!selectedFilterName"
          (p-click)="editFilter()">
        </po-button>
        <po-button
          p-icon="an an-trash"
          p-label="{{ literals?.str0235 }}"
          p-kind="tertiary"
          p-danger="true"
          [p-disabled]="!selectedFilterName"
          (p-click)="deleteFilter()">
        </po-button>
      </div>
    </div>

    <div class="po-row po-mb-2">
      <div class="po-md-6 keep-filter-row">
        <po-switch
          p-label="{{ literals?.str0883 }}"
          p-label-on="{{ literals?.str0099 }}"
          p-label-off="{{ literals?.str0100 }}"
          [(ngModel)]="keepFilterActive"
          [p-disabled]="!selectedFilterName"
          (p-change)="handleKeepFilterActiveChange()">
        </po-switch>
        <span
          class="po-ml-1 po-mb-5 an an-warning-circle exclamation keep-filter-tooltip"
          p-tooltip="{{ literals?.str0884 }}"
          p-tooltip-position="right">
        </span>
      </div>
    </div>

    <po-divider></po-divider>

    <!-- Indicador de modo edição -->
    @if (isEditMode) {
      <div class="po-row po-mb-1">
        <po-tag
          p-color="color-08"
          p-icon="an an-pencil-simple"
          [p-value]="(literals?.str0917 || '') + editingFilterName">
        </po-tag>
      </div>
    }

    <!-- Formulário para adicionar critério -->
    <p class="po-font-text-large po-mb-1">{{literals.str0885}}</p>

    <div class="po-row">
      <div class="po-md-4">
        <po-select
          p-label="{{ literals?.str0886 }}"
          p-placeholder="{{ literals?.str0887 }}"
          [p-options]="fieldOptions"
          [(ngModel)]="selectedField"
          [p-disabled]="criteriaFieldsDisabled"
          (p-change)="onFieldChange($event)">
        </po-select>
      </div>
      <div class="po-md-3">
        <po-select
          p-label="{{ literals?.str0888 }}"
          [p-options]="operatorOptions"
          [(ngModel)]="selectedOperator"
          [p-disabled]="criteriaFieldsDisabled">
        </po-select>
      </div>
      <div class="po-md-3">
        @if (selectedFieldType === 'D') {
          <po-datepicker
            p-label="{{ literals?.str0889 }}"
            p-placeholder="{{ literals?.str0890 }}"
            p-format="dd/MM/yyyy"
            [(ngModel)]="expressionDateValue"
            [p-disabled]="criteriaFieldsDisabled">
          </po-datepicker>
        } @else {
          <po-input
            p-label="{{ literals?.str0889 }}"
            p-placeholder="{{ literals?.str0891 }}"
            [(ngModel)]="expressionValue"
            [p-disabled]="criteriaFieldsDisabled">
          </po-input>
        }
      </div>
      <div class="btn-add po-md-2 po-mt-4">
        <po-button
          p-icon="an an-plus"
          p-label="{{ literals?.str0727 }}"
          p-kind="secondary"
          [p-disabled]="criteriaFieldsDisabled"
          (p-click)="addCriteria()">
        </po-button>
      </div>
    </div>

    <!-- Visualização dos critérios montados -->
    @if (currentCriteria.length > 0) {
      <div class="pgc-filter-criteria-list po-mt-3">
        <p class="po-font-text-large po-mb-1">{{literals.str0892}}</p>

        <div class="po-row po-mb-1">
          @for (criteria of currentCriteria; track criteria; let i = $index) {
            <div class="pgc-filter-criteria-item po-md-12 po-mb-1">
              <po-tag
                p-color="color-08"
                [p-value]="criteria.fieldLabel + ' ' + criteria.operatorLabel + ' ' + criteria.value">
              </po-tag>
              <po-button
                class="po-ml-1"
                p-icon="an an-x"
                p-kind="tertiary"
                p-danger="true"
                (p-click)="removeCriteria(i)">
              </po-button>
            </div>
          }
        </div>

        <div class="po-row">
          <po-button
            class="po-mr-2"
            p-icon="an an-eraser"
            p-label="{{ literals?.str0893 }}"
            p-kind="tertiary"
            (p-click)="clearCriteria()">
          </po-button>
        </div>
      </div>
    }

    <po-divider></po-divider>

    <!-- Salvar filtro -->
    <div class="po-row po-mt-2">
      <div class="po-md-5">
        <po-input
          p-label="{{ literals?.str0894 }}"
          p-placeholder="{{ literals?.str0895 }}"
          [(ngModel)]="newFilterName"
          [p-disabled]="isEditMode">
        </po-input>
      </div>
      <div class="btn-save po-md-3 po-mt-4">
        @if (isEditMode) {
          <po-button
            p-icon="an an-floppy-disk"
            p-label="{{ literals?.str0896 }}"
            p-kind="primary"
            [p-disabled]="currentCriteria.length === 0"
            (p-click)="saveEditedFilter()">
          </po-button>
          <po-button
            class="po-ml-1"
            p-label="{{ literals?.str0897 }}"
            p-kind="tertiary"
            (p-click)="cancelEdit()">
          </po-button>
        } @else {
          <po-button
            p-icon="an an-floppy-disk"
            p-label="{{ literals?.str0286 }}"
            p-kind="secondary"
            [p-disabled]="currentCriteria.length === 0"
            (p-click)="saveFilter()">
          </po-button>
        }
      </div>
    </div>

  </po-modal>

</div>
